import { render, staticRenderFns } from "./benefits.vue?vue&type=template&id=095d7502"
import script from "./benefits.vue?vue&type=script&lang=js"
export * from "./benefits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports